export const formatValue = (
  unit: "CUSTOM" | "CURRENCY",
  maxValue?: number
): [(val: number | undefined | null) => string, string | undefined] => {
  const cmpValue = maxValue ?? 0;
  switch (unit) {
    case "CURRENCY":
      if (cmpValue >= 1000000) {
        return [divideNum(1000000), "mkr"];
      }
      if (cmpValue >= 10000) {
        return [divideNum(1000), "tkr"];
      }
      return [divideNum(1), "kr"];
    default:
      if (cmpValue >= 1000000) {
        return [divideNum(1000000), "M"];
      }
      if (cmpValue >= 10000) {
        return [divideNum(1000), "K"];
      }
      return [divideNum(1), undefined];
  }
};

const divideNum = (div: number) => (value: number | null | undefined) => {
  if (value === undefined || value === null || div === 0) {
    return "";
  }
  const l = `${Math.round(value / div)}`.length;
  const decimals = Math.max(3 - l, 0);
  return `${
    Math.round((value / div) * Math.pow(10, decimals)) / Math.pow(10, decimals)
  }`;
};
